import { Component, EventEmitter, Input, OnDestroy, Output, inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { finalize, tap } from "rxjs/operators";
import {
  CstFormBuilder,
  CstFormGroup,
} from "src/app/_uncategorised_models_services/cst-form-group";
import { CstFileViewerService } from "src/app/common-components/file-viewers/services/file-viewer.service";
import { AlertService } from "src/app/services";
import {
  AnlageLookupDto,
  AnlagenClientProvider,
  FacilityInformationPageClientProvider,
  FacilityInformationPagesPdfsCreateCommand,
  IFacilityInformationPagesPdfsCreateCommand,
} from "src/app/web-api/web-api";

@Component({
    selector: "app-facility-information-pages-pdfs-create",
    templateUrl: "./facility-information-pages-pdfs-create.component.html",
    styleUrls: ["./facility-information-pages-pdfs-create.component.scss"],
    standalone: false
})
export class AnlageApiFacilityInformationPagesPdfsCreateComponent
  implements OnDestroy
{
  private _client = inject(FacilityInformationPageClientProvider);
  private _facilityClient = inject(AnlagenClientProvider);
  private _fileViewerService = inject(CstFileViewerService);
  private _alrtService = inject(AlertService);

  private _subs = new Subscription();

  public loading = false;
  public facilityInfos: AnlageLookupDto[] = [];
  public form: CstFormGroup<IFacilityInformationPagesPdfsCreateCommand> = null;

  @Input() set facilityIDs(value: number[]) {
    const local = this.facilityIDs;
    if (
      local === value ||
      (local &&
        value &&
        local.length === value.length &&
        local.every((x, i) => x === value[i]))
    ) {
      return;
    }
    this.form.patchValue({
      facilityIDs: value
        ? value.map((x) => (typeof x === "string" ? Number.parseInt(x, 10) : x))
        : [],
    });
  }
  get facilityIDs() {
    return this.form.value.facilityIDs;
  }

  @Output() facilityIDsChange = new EventEmitter<number[]>();

  public constructor() {
    const fb = inject(CstFormBuilder);

    this.form = fb.group<IFacilityInformationPagesPdfsCreateCommand>({
      templateID: new FormControl(null, Validators.required),
      facilityIDs: new FormControl([], Validators.required),
    });
    this._subs.add(
      this.form.controls.facilityIDs.valueChanges.subscribe((value) => {
        this._refreshFacilityInfos(value);
        this.facilityIDsChange.emit(value);
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  public createPdfs() {
    const val = this.form.value;
    return this._client
      .pdfsCreate(new FacilityInformationPagesPdfsCreateCommand(val))
      .pipe(
        tap((result) => {
          this._fileViewerService.tryDisplayFileResponse(result);
          this._alrtService.showSnackbar(
            val.facilityIDs.length > 1
              ? $localize`:@@AnlageAPI_FacilityInformationPages_PdfsCreate_SuccessfulMulti:Pdfs created successfully`
              : $localize`:@@AnlageAPI_FacilityInformationPages_PdfsCreate_SuccessfulSingle:Pdf created successfully`,
            { type: "info", duration: "short" }
          );
        })
      );
  }

  onFacilityRemove(facility: AnlageLookupDto) {
    this.facilityIDs = this.facilityIDs.filter((x) => x !== facility.anlageID);
  }

  private _refreshFacilityInfos(facilityIDs: number[]) {
    if (!facilityIDs) {
      facilityIDs = [];
    }
    this.loading = true;
    this.facilityInfos = this.facilityInfos.filter((x) =>
      facilityIDs.includes(x.anlageID)
    );
    const added = facilityIDs.filter(
      (x) => this.facilityInfos.findIndex((f) => f.anlageID == x) === -1
    );
    if (!added || added.length === 0) {
      this.loading = false;
      return;
    }
    this._facilityClient
      .getListByIDs(added)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((result) => {
        this.facilityInfos.push(...result);
      });
  }
}
